import * as React from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {
  selectEmailDebugMode,
  selectUserContentSubscriptionExternal,
} from 'src/selectors/content-subscription';
import {getUnSubscribeApiDataV2} from 'src/utils/content-subscription';
import {saveUserSubscriptionApiV2} from 'src/action-creators/content-subscription';

import UnsubscribeComponent from 'src/components/content-subscription/manage/unsubscribe-content-category';


const Unsubscribe = (params: {
  trackingId?: string;
  unsubscribeCategoryId: string | null | undefined;
}) => {
  const dispatch = useDispatch();
  const [success, setSuccess] = React.useState(false);
  const [alreadyUnsubscribed, setAlreadyUnsubscribed] = React.useState(false);
  const isDebug = useSelector(selectEmailDebugMode);
  const trackingId = params.trackingId ?? '';
  const category = useSelector((state) => {
    if (trackingId) {
      const userSubscriptions = selectUserContentSubscriptionExternal(
        state,
        trackingId,
      );
      if (userSubscriptions) {
        return userSubscriptions.find(
          (sub) =>
            sub.content_subscription_category_id ===
            Number(params.unsubscribeCategoryId),
        );
      }
    }
    return null;
  });

  React.useEffect(() => {
    if (category && category.subscription[0]?.is_subscribed === false) {
      setAlreadyUnsubscribed(true);
    }
  }, [category]);

  const onUnsubscribe = async () => {
    const apiData = getUnSubscribeApiDataV2(
      Number(params.unsubscribeCategoryId),
      // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
      category?.subscription[0].attribute_value,
    );
    try {
      await dispatch(saveUserSubscriptionApiV2(apiData, trackingId, true));
      setSuccess(true);
    } catch (e: any) {}
  };

  return (
    <UnsubscribeComponent
      success={success}
      isDebugEntity={isDebug}
      // @ts-expect-error - TS2322 - Type 'UserContentSubscription | null | undefined' is not assignable to type 'UserContentSubscription'.
      category={category}
      alreadyUnsubscribed={alreadyUnsubscribed}
      onUnsubscribe={onUnsubscribe}
      redirectLink={`/content-subscription/manage/tracking-id/${trackingId}`}
    />
  );
};

export default Unsubscribe;
